import { render, staticRenderFns } from "./IconCaret.vue?vue&type=template&id=688f3a60"
import script from "./IconCaret.vue?vue&type=script&lang=js"
export * from "./IconCaret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports